import { render } from "./QC4.vue?vue&type=template&id=c1404af2"
import script from "./QC4.vue?vue&type=script&lang=js"
export * from "./QC4.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QCCharts/microgen/QC4.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c1404af2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c1404af2', __exports__)) {
    console.log('reload')
    api.reload('c1404af2', __exports__)
  }
  
  module.hot.accept("./QC4.vue?vue&type=template&id=c1404af2", () => {
    console.log('re-render')
    api.rerender('c1404af2', render)
  })

}


export default __exports__